import { Installation } from "../Installation";
import { AgentTunnelSession } from "./AgentTunnelSession";
import { InstalledSoftware } from "@/model/data/InstalledSoftware";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";

export class InstallationRemoteLinkStatus extends Installation {
    installationHasActiveSessions: boolean = false;
    httpSession: AgentTunnelSession;
    caosDbSession: AgentTunnelSession;
    sshSession: AgentTunnelSession;
    ultravncSession: AgentTunnelSession;
    cserviceSession: Array<AgentTunnelSession>;
    customProtocolSessions: Array<AgentTunnelSession>;
    agent: Array<InstalledSoftware> = null;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);
        if (obj.InstallationHasActiveSessions) this.installationHasActiveSessions = obj.InstallationHasActiveSessions;
        if (obj.HTTPSession) {
            this.httpSession = new AgentTunnelSession();
            this.httpSession.parse(obj.HTTPSession);
        }
        if (obj.CaosDbSession) {
            this.caosDbSession = new AgentTunnelSession();
            this.caosDbSession.parse(obj.CaosDbSession);
        }
        if (obj.SSHSession) {
            this.sshSession = new AgentTunnelSession();
            this.sshSession.parse(obj.SSHSession);
        }
        if (obj.UltraVNCSession) {
            this.ultravncSession = new AgentTunnelSession();
            this.ultravncSession.parse(obj.UltraVNCSession);
        }
        if (obj.CServiceSession) {
            this.cserviceSession = new Array<AgentTunnelSession>();
            obj.CServiceSession.forEach((session) => {
                let s = new AgentTunnelSession();
                s.parse(session);
                this.cserviceSession.push(s);
            });
        }
        if (obj.CustomProtocolSessions) {
            this.customProtocolSessions = new Array<AgentTunnelSession>();
            obj.CustomProtocolSessions.forEach((session) => {
                let s = new AgentTunnelSession();
                s.parse(session);
                this.customProtocolSessions.push(s);
            });
        }

        if (obj.AgentInfo && obj.AgentInfo.Version) {
            this.agent = new Array<InstalledSoftware>();
            let agentSoftware = new InstalledSoftware();
            agentSoftware.name = "Agent";
            agentSoftware.version = obj.AgentInfo.Version;
            agentSoftware.updateType = UpdateTypeEnum.Agent;
            this.agent.push(agentSoftware);
        }
    }
}
